export const getObjectDeepValue = (data: Record<string, unknown>, path: string) =>
  // TODO: get rid of type casting
  path.split('.').reduce((value, key) => value?.[key] as Record<string, unknown>, data);
